export default __webpack_public_path__ + "static/media/03.0111f2c0.jpg";